/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import OutlinedTextField from './components/text-fields/outlined-text-field';
import Api from './services/Api';
import CoreApi from './services/CoreApi';
import useCookie from './use-cookie';

const useStyles = makeStyles((theme) => ({
  loginCard: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: '',
    color: theme.palette.primary.contrastText,
    marginTop: '-150px',
  },
  loginGrid: {
    backgroundColor: theme.palette.background.default,
    height: '100vh',
  },
}));

const Login = ({ appName, onLogin }) => {
  const classes = useStyles();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [cookie, setCookie] = useCookie();

  const login = useCallback(
    ({ token, user }) => {
      Api.setToken(token);
      Api.setUser(user);
      onLogin(true, token, user);
    },
    [onLogin],
  );

  useEffect(() => {
    cookie && login(cookie);
  }, [cookie, login, onLogin]);

  const onClick = useCallback(async () => {
    try {
      const { token, user } = await CoreApi.login(name, password);
      Api.setToken(token);
      Api.setUser(user);
      setCookie({ token, user });
      onLogin(true, token, user);
    } catch (error) {
      alert('not found');
      console.error('login error', error);
    }
  }, [name, onLogin, password, setCookie]);

  return (
    <Grid
      alignItems='center'
      className={classes.loginGrid}
      container
      direction='row'
      justify='center'
      spacing={0}
    >
      <Grid item xs={12} md={8}>
        <Card
          className={classNames(
            'loginCard',
            classes.loginCard,
            'animated',
            'fadeIn',
          )}
          raised
        >
          <CardContent>
            <div className='loginHeader' />
            <div className='loginContent'>
              <Typography variant='h6' color='inherit'>
                {appName}
              </Typography>

              <form noValidate autoComplete='off'>
                <OutlinedTextField
                  autoFocus
                  label='Name'
                  onChange={setName}
                  value={name}
                />
                <OutlinedTextField
                  label='Password'
                  onChange={setPassword}
                  onEnter={onClick}
                  type='password'
                  value={password}
                />
              </form>
            </div>
          </CardContent>
          <CardActions>
            <Button
              variant='contained'
              color='default'
              fullWidth
              onClick={onClick}
            >
              Login
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Login;
